import { z } from 'zod';
import { CorrectionRequestInputSchema } from './attendance.schema.js';

/**
 * `POST /api/corrections` — a correction request, optionally FOR SOMEBODY ELSE.
 *
 * "Fix attendance" could only fix the caller's own record: the route took the
 * employee from the session and the body had nowhere to name anyone. An admin
 * fixing a worker's missed punch had to go round through the raw manual-punch
 * tool, which writes no reason and tells nobody. `employeeId` names the worker;
 * absent, it is the caller as before. Who may name someone else is the route's
 * decision, not the schema's.
 *
 * Its own file because attendance.schema.ts is at its 500-line budget.
 */
export const CorrectionFileSchema = CorrectionRequestInputSchema.extend({
  employeeId: z.string().min(1).optional(),
});
export type CorrectionFileInput = z.infer<typeof CorrectionFileSchema>;
